import { ValidationRuleSchema } from 'vee-validate/dist/types/types'

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/

const Password: ValidationRuleSchema = {
  validate(value: string): boolean {
    return PASSWORD_REGEX.test(value)
  },
}

export default Password
